import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

import { IPreparedRouter } from '~/src/entities/speed-bonus/context/actions/setRouters';
import { ISpeedBonusTariff } from '~/src/entities/speed-bonus/context/actions/setTariff';

const defaultLabel = 'default_label';

type TSpeedBonusAnalyticsTariff = Pick<ISpeedBonusTariff, 'title' | 'connectionFlow' | 'shopItemId'>

class SpeedBonusConnectionAnalytics extends BaseAnalytics {
    private tariff: TSpeedBonusAnalyticsTariff | undefined;

    constructor(category = 'VAS') {
        super();
        this.category = category;
    }

    public setTariff(tariff: TSpeedBonusAnalyticsTariff) {
        this.tariff = tariff;
    }

    startConnection() {
        this.sendWithLabel('click_connect_promo', defaultLabel);
    }

    successConnected() {
        this.sendWithLabel('promo_connected_successfully', defaultLabel);
    }

    connectionError() {
        this.sendWithLabel('error_while_promo_connection', defaultLabel);
    }

    openConnectionConfirmation() {
        this.sendWithLabel('open_page_speed_bonus_cart', defaultLabel);
    }

    openRouterSelection() {
        this.sendWithLabel('open_choose_router_for_speed_bonus', defaultLabel);
    }

    routerSelection(router?: IPreparedRouter) {
        if (router) {
            const { title, selectedPrice: { cost, duration } } = router;

            const purchaseType = duration > 0 ? `Рассрочка (${duration} мес.)` : 'В собственность';
            const routerLabel = `router_name:${title}|payment:${purchaseType}|cost:${cost}`;

            this.sendWithLabel('click_connect_bonus_after_chose_router', routerLabel);
        } else {
            this.sendWithLabel('click_connect_bonus', defaultLabel);
        }
    }

    requestCreated(withLabel: boolean) {
        this.sendWithLabel('request_created_successfully', withLabel ? defaultLabel : undefined);
    }

    timeSlotsUnavailable() {
        this.sendWithLabel('time_slots_are_not_available');
    }

    confirmTimeSlotSelection() {
        this.sendWithLabel('click_confirm_after_choosing_time_slot');
    }

    timeSlotSuccessConfirmed() {
        this.sendWithLabel('time_slot_confirmed_successfully');
    }

    timeSlotConfirmationError() {
        this.sendWithLabel('time_slot_confirmation_error');
    }

    private getAnalyticsLabel() {
        if (!this.tariff) {
            throw new Error('speedBonusConnectionAnalytics.setTariff must be called first');
        }

        const { title, connectionFlow, shopItemId } = this.tariff;
        return `name:${title}|promo_type:${connectionFlow}|id:${shopItemId}`;
    }

    private sendWithLabel(action: string, incomingLabel?: string) {
        const label = (() => {
            if (incomingLabel) {
                const labelByDefault = this.getAnalyticsLabel();

                if (incomingLabel !== defaultLabel) {
                    return `${labelByDefault}|${incomingLabel}`;
                }

                return labelByDefault;
            }
        })();

        this.send(action, label);
    }
}

export const speedBonusConnectionAnalytics = new SpeedBonusConnectionAnalytics();
